(function (angular) {
    'use strict';

    angular.module('broadcast')
        /**
         * 
         */
        .directive('expiryPeriod', function () {

            var linkFn = function ($scope, element, attrs, form) {

                $scope.options = {
                    timeSpanValue: 1440,
                    expiryAfter: 3
                };

                $scope.model = $scope.model ? $scope.model : $scope.options.expiryAfter * $scope.options.timeSpanValue;

                // $scope.model = $scope.options.expiryAfter * $scope.options.timeSpanValue;

                //deploy
                $scope.timeSpan = [{
                    label: 'minutes',
                    value: 1
                },
                {
                    label: 'hours',
                    value: 60
                },
                {
                    label: 'days',
                    value: 1440
                }];


                // initialise the fields ...

                if ($scope.model / 1440 > 1) {
                    if ($scope.model % 1440 == 0) {
                        $scope.options.timeSpanValue = 1440;
                        $scope.options.expiryAfter = $scope.model / 1440;
                    } else if ($scope.model % 60 == 0) {
                        $scope.options.timeSpanValue = 60;
                        $scope.options.expiryAfter = $scope.model / 60;
                    } else {
                        $scope.options.timeSpanValue = 1;
                    }
                } else if ($scope.model % 60 == 0) {
                    $scope.options.timeSpanValue = 60;
                    $scope.options.expiryAfter = $scope.model / 60;
                } else {
                    $scope.options.timeSpanValue = 1;
                }




                $scope.checkValidity = function () {
                    if ($scope.options.timeSpanValue * $scope.options.expiryAfter > 4320) {
                        switch ($scope.options.timeSpanValue) {
                            case 1:
                                $scope.options.expiryAfter = 4320;
                                break;
                            case 60:
                                $scope.options.expiryAfter = 72;
                                break;
                            case 1440:
                                $scope.options.expiryAfter = 3;
                        }
                    }

                    $scope.model = $scope.options.expiryAfter * $scope.options.timeSpanValue;
                }

                $scope.checkValidity();

            };

            return {
                restrict: 'EA', //Default in 1.3+
                require: '^form'/*, 'ngModel'*/,
                scope: {
                    model: "=",
                },
                link: linkFn,
                templateUrl: 'components/toolkit/broadcast/templates/directive.expiry.html'
            };

        });
})(window.angular);